export default import.meta.ROLLDOWN_FILE_URL_$v1ZYU7ra4yFY22BtcVgkA